import { Table } from "react-bootstrap";
import editIcon from "../../assets/images/icons/edit.svg";
import deleteIcon from "../../assets/images/icons/delete.svg";

function DataTable({
  columns = [],
  data = [],
  onEdit = null,
  onDelete = null,
  footer,
  emptyMessage = "No records found",
}) {
  const showActions = Boolean(onEdit || onDelete);

  const renderActions = (row) => {
    if (row.relationship === "Primary") return null;

    return (
      <div className="d-flex align-items-center gap-2">
        {onEdit && (
          <img
            className="me-2"
            src={editIcon}
            alt="edit"
            width={20}
            style={{ cursor: "pointer" }}
            onClick={() => onEdit(row)}
          />
        )}

        {onDelete && (
          <img
            src={deleteIcon}
            alt="delete"
            width={20}
            style={{ cursor: "pointer" }}
            onClick={() => onDelete(row)}
          />
        )}
      </div>
    );
  };

  return (
    <div className="tables">
      <Table hover responsive className="align-middle mb-0">
        <thead>
          <tr className="table-light">
            {columns?.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {showActions && <th style={{ width: 80 }}>Actions</th>}
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data?.map((row) => (
              <tr key={row?._id} className="table-rows">
                {columns?.map((col) => (
                  <td key={col?.key}>
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}

                {showActions && <td>{renderActions(row)}</td>}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length + (showActions ? 1 : 0)}
                className="text-center py-4 text-muted"
              >
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
        {footer && (
          <tfoot>
            <tr>
              <td colSpan={columns.length + (showActions ? 1 : 0)}>
                <div>{footer}</div>
              </td>
            </tr>
          </tfoot>
        )}
      </Table>
    </div>
  );
}

export default DataTable;
